import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap';
import { Checkbox, Radio } from 'react-icheck';
import PrintPreview from './PrintPreview';
import HrStore from '../../stores/HrStore';

class PrintReportContractorWageTable extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false,data:[],pdf_config:{signature:[]}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('landscape');
  }

  componentDidMount(){
    this.loadAllSlipContractor()
  }

  loadAllSlipContractor() {
    let {year,month,week} = this.props
    let rang = {value:week}
    let that = this
    that.setState({loading:true})
    HrStore.loadAllSlipContractor(year,month,rang,function(result) {
      that.setState({loading:false,data:result.data,pdf_config:result.pdf_config})
    })

  }

  getNumberFormat(number) {
    if (number===''||isNaN(number)) {
      return '0.00'
    } else {
      return parseInt(number).toLocaleString(undefined, {minimumFractionDigits: 2})
    }  
  }

  getSummary(key) {
    let {data} = this.state
    let sum = 0
    data.forEach(function(item,index) {
      sum = parseInt(item[key]) + parseInt(sum)
    })
    return this.getNumberFormat(sum)
  }

  renderRowData() {
    let {data} = this.state
    if (data===undefined||data.length===0) {
      return(<tr><td colSpan={10}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index) => {
          return(
            <tr key={index}>        
              <td className='text-center font-print'>{index+1}</td>
              <td className='font-print'>{item.first_name}</td>
              <td className='font-print'>{item.last_name}</td>
              <td className='font-print'>{item.nick_name}</td>
              <td className='font-print'>{item.position}</td>
              <td className='text-right font-print'>{this.getNumberFormat(item.income_fixing)}</td>
              <td className='text-right font-print'>{this.getNumberFormat(item.total_withdraw)}</td>
              <td className='text-right font-print'>{this.getNumberFormat(item.total_deduction)}</td> 
              <td className='text-right font-print text-red'>{this.getNumberFormat(item.net_income)}</td> 
              <td className='text-right font-print'>{this.getNumberFormat(item.net_payable)}</td>        
            </tr>
          )
        })
      )
    }
  }

  renderSignature(){
    let {pdf_config} = this.state
    if(pdf_config.signature!==undefined && pdf_config.signature.length>0){
      return (
        <table className='table table-print-report-contractor-wage-foot'>
              <tbody>
                <tr>
                  {pdf_config.signature.map((item,index)=>(
                    <td className='text-center font-print'>
                    .....................................................................<br/>
                    {item.name}<br/>
                    {item.reponsible}
                  </td>
                  ))}                  
                </tr>
              </tbody>
            </table>
      )
    }else{
      return (<div/>)
    }
  }

  renderComponentPage() {
    return(
      <div className='font-print'>
        <div className='text-center font-24'>{'ตารางการจ่ายเงินช่างเหมา ประจำวันที่ '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}</div>
        <table className='table table-print-report-contractor-wage'>
          <tbody>
            <tr>
              <td className='text-center font-print'>ลำดับ</td>
              <td className='text-center font-print'>ชื่อ</td>
              <td className='text-center font-print'>นามสกุล</td>   
              <td className='text-center font-print'>ชื่อเล่น</td>            
              <td className='text-center font-print'>ตำแหน่ง</td>
              <td className='text-center font-print'>ราคาเหมา</td>
              <td className='text-center font-print'>เบิกจ่าย</td>
              <td className='text-center font-print'>รายหักทั้งหมด</td>
              <td className='text-center font-print text-red'>คงเหลือจ่ายจริง</td>
              <td className='text-center font-print'>คงเหลือค้างจ่าย</td>
            </tr>
            {this.renderRowData()}
          </tbody>
          <tfoot>
            <tr>
              <th className='bg-yellow font-print' colSpan={5}>รวมค่าแรงช่างเหมา</th>
              <th className='text-right bg-yellow font-print text-black'>{this.getSummary('income_fixing')}</th>
              <th className='text-right bg-yellow font-print text-black'>{this.getSummary('total_withdraw')}</th>
              <th className='text-right bg-yellow font-print text-black'>{this.getSummary('total_deduction')}</th>
              <th className='text-right bg-yellow font-print text-red'>{this.getSummary('net_income')}</th>
              <th className='text-right bg-yellow font-print text-black'>{this.getSummary('net_payable')}</th>
            </tr>
          </tfoot>
        </table>
        <center>
        <div className='footer-page-landscape'>
          {this.renderSignature()}
        </div>
        </center>
      </div>
    )
  }  

  getTextMonth(month) {
    let text = ''
    if (month==='01'){
      text = 'มกราคม'
    } else if (month==='02'){
      text = 'กุมภาพันธ์'
    } else if (month==='03'){
      text = 'มีนาคม'
    } else if (month==='04'){
      text = 'เมษายน'
    } else if (month==='05'){
      text = 'พฤษภาคม'
    } else if (month==='06'){
      text = 'มิถุนายน'
    } else if (month==='07'){
      text = 'กรกฎาคม'
    } else if (month==='08'){
      text = 'สิงหาคม'
    } else if (month==='09'){
      text = 'กันยายน'
    } else if (month==='10'){
      text = 'ตุลาคม'
    } else if (month==='11'){
      text = 'พฤศจิกายน'
    } else if (month==='12'){
      text = 'ธันวาคม'
    }
    return text
  }

  render() {
    let {loading} = this.state
    
    return(
      <PrintPreview 
        loading={loading}
        size={'landscape'} 
        leftBarTitle={'ตารางการจ่ายเงินช่างเหมา ประจำวันที่ '+this.props.week+' '+this.getTextMonth(this.props.month)+' '+this.props.year}>
        {this.renderComponentPage()}
      </PrintPreview>
    )
  }

}

export default PrintReportContractorWageTable;  


// WEBPACK FOOTER //
// ./src/view/print/PrintReportContractorWageTable.js